import { apiGet } from './client';

// Mirror of ChatModelDescriptor from ProviderContracts.cs.
export interface ChatModelDescriptor {
  chatModelId: string;      // "providerId:modelName"
  providerId: string;
  providerName: string;
  modelName: string;
  displayLabel: string;
  tierHint: string | null;  // "fast" | "balanced" | "reasoning"
  isConfigured: boolean;
  supportsChat: boolean;
}

export const listChatModels = (configuredOnly = true) =>
  apiGet<ChatModelDescriptor[]>(
    `/api/models${configuredOnly ? '?configured=true' : ''}`,
  );
